import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { type ListResponse } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { City } from 'src/features/parkingManagement/types/parking';

const RESOURCE = '/parkings/parking-city/';

type QueryFnType = typeof queryFn;
const queryFn = (): Promise<ListResponse<City>> => {
    return axios.get(formatResourcePath(RESOURCE));
};

interface UseQueryHookOptions {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE],
        queryFn: async () => await queryFn(),
        ...config,
    });

export { useQueryHook as useGetCityList };
